import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "login col-12 col-sm-4 offset-sm-4 offset-lg-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "login-underlay" }, " ", -1)
const _hoisted_6 = { class: "login-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "PULSE", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"stick-to-bottom\"><div class=\"row\"><div class=\"col-6 col-md-3 offset-md-3 text-center\"><a href=\"#\">Terms of use</a></div><div class=\"col-6 col-md-3 text-center\"><a href=\"#\">Privacy policy</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_view),
              _hoisted_8
            ])
          ])
        ])
      ]))
}